import * as customerSelectors from './selectors';

export const selectors = customerSelectors;
export * from './actions';
export { default as reducer } from './reducer';
